<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Presentation options for this field']"
    >
    <mat-icon fontIcon="label"></mat-icon>
    <h3>
      Presentation options
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>

  <!-- style taken from button-toggle-grid -->
  @if (expanded) {
    <span
    style="
      display: grid;
      grid-template-columns: auto min-content;
      grid-gap: 10px;
      align-items: center;
      margin-bottom: 9px;
      padding-bottom: 13px;
    "
      >
      <p class="grey" style="font-size: 9px">{{ optionsDescription }}</p>
      <div>
        <mat-button-toggle-group
          name="presentation"
          aria-label="Presentation"
          [(ngModel)]="useDisplayValue"
          (change)="updateParent()"
          [hideSingleSelectionIndicator]="true"
          >
          <mat-button-toggle [value]="false">Value</mat-button-toggle>
          <mat-button-toggle [value]="true">Display Value</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </span>
  }
</section>
